export default class PvApiNotFoundException extends Error {
    constructor() {
        super();
        this.name = '404 Not Found';
        this.message = 'Не найдено';
    }
}